import { useState } from 'react';
import { toast } from 'react-toastify';

const useSendEmail = () => {
  const [isSending, setIsSending] = useState(false);

  const sendEmail = async ({ to, subject, html }) => {
    const FUNCTION_URL = "https://sendemail-mtb6ihbkka-uc.a.run.app/sendEmail";
    setIsSending(true);
    const toastId = toast.loading("Sending confirmation email...");

    try {
      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to, subject, html }),
      });

      const result = await response.json();

      if (result.success) {
        toast.update(toastId, { 
          render: "Receipt sent to your email!", 
          type: "success", 
          isLoading: false, 
          autoClose: 3000 
        });
        return { success: true };
      } else {
        throw new Error(result.error || "Failed to send email");
      }
    } catch (error) {
      console.error("Email Hook Error:", error);
      toast.update(toastId, { 
        render: `Email failed: ${error.message}`, 
        type: "error", 
        isLoading: false, 
        autoClose: 5000 
      });
      return { success: false, error: error.message };
    } finally {
      setIsSending(false);
    }
  };

  return { sendEmail, isSending };
};

export default useSendEmail;